import React from "react";
import makeAsyncScriptLoader from "react-async-script";

function withExternalJsScript(url, WrappedComponent, urlOptions) {
  const LoadingElement = () => {
    return <div>Loading...</div>;
  };

  class Wrapper extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        scriptLoaded: false,
      };
    }
    render() {
      const AsyncScriptLoader = makeAsyncScriptLoader(
        url,
        urlOptions
      )(LoadingElement);
      if (this.state.scriptLoaded) {
        return <WrappedComponent {...this.props} />;
      }
      return (
        <AsyncScriptLoader
          asyncScriptOnLoad={() => {
            this.setState({ scriptLoaded: true });
          }}
        />
      );
    }
  }
  return Wrapper;
}
export default withExternalJsScript;
